module.exports = __webpack_public_path__ + "json/buildings-1.json?366a1572e1d2b3ed7bd98e99367688c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-1.json
// module id = 1715
// module chunks = 3